var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":`${_vm.id}-input`}},[_c('vue-editor',{ref:"vue2Editor",staticClass:"editor-input",class:_vm.class_style,attrs:{"id":_vm.id,"editorToolbar":_vm.customToolbar,"disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }